import "core-js/modules/es6.object.assign";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { xinli } from '@/api/api_url';
import { getToken } from '@/libs/util';
import { renderFormMixins } from '@/mixins/renderFormMixins';
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      center: {
        lng: 0,
        lat: 0
      },
      zoom: 3,
      BMap: null,
      position: {},
      uploadList: [],
      refName: 'refName',
      headers: {
        Authorization: getToken()
      },
      hasDisabled: true,
      fileName: 'image',
      fileData: {
        client_id: ""
      },
      format: ['jpg', 'jpeg', 'png'],
      visible: false,
      imgName: '',
      uploadData: {
        client_id: null
      },
      uploadHeaders: {
        "Authorization": getToken()
      },
      proAttrFile: {},
      formModel: {
        cate_name: null //姓名

      },
      formRules: {
        cate_name: [{
          required: true,
          message: '分类名称不能为空',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {}
  },
  components: {},
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + xinli.upload_pic;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + xinli.upload_pic;
      } else {
        result = config.baseUrl.alp + "" + xinli.upload_pic;
      }

      return result;
    }
  },
  methods: {},
  mounted: function mounted() {
    if (this.edit) {
      if (this.setData) {
        Object.assign(this.formModel, this.setData);
      }
    }
  },
  created: function created() {}
};